export type ReconnectionResultState = {
  status?: string;
  operationKind?: 'single' | 'all';
  operationLabel?: string;
  phaseLabel?: string;
  detail?: string;
  startedAt?: string;
  completedAt?: string;
  refreshedAt?: string;
  validationId?: number;
  pollingAttempt?: number;
  refreshState?: string;
  refreshMessage?: string;
  processed?: number;
  percent?: number | null;
  elapsedMs?: number;
  etaMs?: number | null;
  waitReason?: string;
  waitElapsedMs?: number;
  activeElapsedMs?: number;
  operationState?: string;
  operationId?: string;
  attemptedPairCount?: number;
  totalPairs?: number;
  successfulReconnections?: number;
  failedReconnections?: number;
  successMessages?: string[];
  errorMessages?: string[];
  reconnectedElementIds?: string[];
  remainingConnectorBreakIssues?: number;
  remainingSystemBreakIssues?: number;
  remainingGeometryOverlapIssues?: number;
  touchedSystemNames?: string[];
  validationGate?: string;
  failureKind?: string;
  rawReconnectSummary?: {
    totalPairs?: number;
    successfulReconnections?: number;
    failedReconnections?: number;
    successMessages?: string[];
    errorMessages?: string[];
    reconnectedElementIds?: string[];
  };
};

export function normalizeReconnectSummary(raw: any) {
  if (!raw || typeof raw !== 'object') {
    return {
      totalPairs: 0,
      successfulReconnections: 0,
      failedReconnections: 0,
      successMessages: [],
      errorMessages: [],
      reconnectedElementIds: [],
    };
  }

  return {
    totalPairs: raw.totalPairs ?? raw.TotalPairs ?? 0,
    successfulReconnections:
      raw.successfulReconnections ?? raw.SuccessfulReconnections ?? 0,
    failedReconnections:
      raw.failedReconnections ?? raw.FailedReconnections ?? 0,
    successMessages: raw.successMessages ?? raw.SuccessMessages ?? [],
    errorMessages: raw.errorMessages ?? raw.ErrorMessages ?? [],
    reconnectedElementIds:
      raw.reconnectedElementIds ?? raw.ReconnectedElementIds ?? [],
  };
}

export function normalizeReconnectionResult(raw: any): any {
  if (!raw || typeof raw !== 'object') {
    return raw;
  }

  const rawReconnectSummary = normalizeReconnectSummary(
    raw.rawReconnectSummary ?? raw.RawReconnectSummary ?? raw
  );

  return {
    ...raw,
    attemptedPairCount:
      raw.attemptedPairCount ?? raw.AttemptedPairCount ?? rawReconnectSummary.totalPairs ?? 0,
    totalPairs: raw.totalPairs ?? raw.TotalPairs ?? rawReconnectSummary.totalPairs ?? 0,
    successfulReconnections:
      raw.successfulReconnections ??
      raw.SuccessfulReconnections ??
      rawReconnectSummary.successfulReconnections ??
      0,
    failedReconnections:
      raw.failedReconnections ??
      raw.FailedReconnections ??
      rawReconnectSummary.failedReconnections ??
      0,
    successMessages:
      raw.successMessages ?? raw.SuccessMessages ?? rawReconnectSummary.successMessages ?? [],
    errorMessages:
      raw.errorMessages ?? raw.ErrorMessages ?? rawReconnectSummary.errorMessages ?? [],
    reconnectedElementIds:
      raw.reconnectedElementIds ??
      raw.ReconnectedElementIds ??
      rawReconnectSummary.reconnectedElementIds ??
      [],
    remainingConnectorBreakIssues:
      raw.remainingConnectorBreakIssues ?? raw.RemainingConnectorBreakIssues ?? 0,
    remainingSystemBreakIssues:
      raw.remainingSystemBreakIssues ?? raw.RemainingSystemBreakIssues ?? 0,
    remainingGeometryOverlapIssues:
      raw.remainingGeometryOverlapIssues ?? raw.RemainingGeometryOverlapIssues ?? 0,
    touchedSystemNames:
      raw.touchedSystemNames ?? raw.TouchedSystemNames ?? [],
    validationGate:
      raw.validationGate ?? raw.ValidationGate ?? 'validation_1_and_22_scoped',
    failureKind: raw.failureKind ?? raw.FailureKind ?? 'none',
    rawReconnectSummary,
  };
}
